import { render, staticRenderFns } from "./NoResponsesDashboardItem.vue?vue&type=template&id=78a7e320"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78a7e320')) {
      api.createRecord('78a7e320', component.options)
    } else {
      api.reload('78a7e320', component.options)
    }
    module.hot.accept("./NoResponsesDashboardItem.vue?vue&type=template&id=78a7e320", function () {
      api.rerender('78a7e320', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dashboard/Items/NoResponsesDashboardItem.vue"
export default component.exports